// extracted by mini-css-extract-plugin
export default {"input":"n_-z","button":"o_-z","selected":"p_-z","unavailable":"q_-z","oos":"r_-z","image":"s_-z","paperCutDisabledOverlay":"t_-z"};